@if (isLoading()) {
  <div class="flex items-center justify-center min-h-screen bg-gray-50">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-mallamas-green-600 mx-auto"></div>
      <p class="mt-4 text-gray-600">Cargando...</p>
    </div>
  </div>
} @else {
  <router-outlet />
}
